import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NoteTypeForm from '../../../components/forms/NoteTypeForm';
import { useNoteTypeApi } from '../../../hooks/useNoteTypeApi';
import { useNavigate } from 'react-router-dom';
import { NoteTypeDTO } from '../../../services/apiClient';

const NoteTypeCreate: React.FC = () => {
  const { create, isLoading } = useNoteTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Note Types', href: '/admin/notetypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: NoteTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/notetypes');
    } catch (error) {
      console.error('Error creating NoteType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/notetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.NoteType.Edit'
    >
        <NoteTypeForm
          initialValues={{} as NoteTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/notetypes')}
        />
    </AdminLayout>
  );
};

export default NoteTypeCreate;